import { createAction, createReducer } from 'redux-act'
import { push } from 'react-router-redux'
import { pendingTask, begin, end } from 'react-redux-spinner'
import { notification } from 'antd'
import firebase from 'firebase'
import axios from 'axios'

const REDUCER = 'app'
const NS = `@@${REDUCER}/`

const _setFrom = createAction(`${NS}SET_FROM`)
const _setLoading = createAction(`${NS}SET_LOADING`)
const _setHideLogin = createAction(`${NS}SET_HIDE_LOGIN`)
export const setUserState = createAction(`${NS}SET_USER_STATE`)
export const setUpdatingContent = createAction(`${NS}SET_UPDATING_CONTENT`)
export const setActiveDialog = createAction(`${NS}SET_ACTIVE_DIALOG`)
export const deleteDialogForm = createAction(`${NS}DELETE_DIALOG_FORM`)
export const addSubmitForm = createAction(`${NS}ADD_SUBMIT_FORM`)
export const deleteSubmitForm = createAction(`${NS}DELETE_SUBMIT_FORM`)
export const setLayoutState = createAction(`${NS}SET_LAYOUT_STATE`)
export const urlServer = 'https://kaizalabackend.herokuapp.com'
export const urlServerKaizala = 'https://kms1.kaiza.la/v1'

export const setLoading = isLoading => {
  const action = _setLoading(isLoading)
  action[pendingTask] = isLoading ? begin : end
  return action
}

var config = {
  apiKey: 'AIzaSyAKcfMlyqTFKNIAW9Ge5e0Sa1nfdGKNgyI',
  authDomain: 'tling-5ce68.firebaseapp.com',
  databaseURL: 'https://tling-5ce68.firebaseio.com',
  projectId: 'tling-5ce68',
  storageBucket: 'tling-5ce68.appspot.com',
  messagingSenderId: '198086332665',
}
firebase.initializeApp(config)

export const resetHideLogin = () => (dispatch, getState) => {
  const state = getState()
  if (state.pendingTasks === 0 && state.app.isHideLogin) {
    dispatch(_setHideLogin(false))
  }
  return Promise.resolve()
}

export const initAuth = roles => (dispatch, getState) => {
  new Date().getTime()
  const suspendSession = new Date(window.localStorage.getItem('suspendSession')).getTime()
  const date = new Date().getTime()
  if (suspendSession < date) {
    logout()
    dispatch(
      setUserState({
        userState: {
          email: '',
          role: '',
        },
      }),
    )
    window.localStorage.clear()
    dispatch(push('/login'))
  }
  const userRole = window.localStorage.getItem('app.Role')
  const userData = window.localStorage.getItem('app.UserData')
    ? JSON.parse(window.localStorage.getItem('app.UserData'))
    : ''
  const state = getState()
  const users = {
    administrator: {
      name: userData.name,
      email: userData.email,
      role: userRole,
    },
  }

  const setUser = userState => {
    dispatch(
      setUserState({
        userState: {
          ...userState,
        },
      }),
    )
    if (!roles.find(role => role === userRole)) {
      if (!(state.routing.location.pathname === '/admin/DashboardTling')) {
        if (userRole === 'redeemman') {
          dispatch(push('/admin/redeemPoints'))
        } else {
          dispatch(push('/admin/DashboardTling'))
        }
      }
      return Promise.resolve(false)
    }
    return Promise.resolve(true)
  }
  switch (userRole) {
    case 'admin':
      return setUser(users.administrator, userRole)
    case 'enterprise':
      return setUser(users.administrator, userRole)

    case 'salesman':
      return setUser(users.administrator, userRole)
    case 'redeemman':
      return setUser(users.administrator, userRole)

    default:
      const location = state.routing.location
      const from = location.pathname + location.search
      dispatch(_setFrom(from))
      dispatch(push('/login'))
      return Promise.reject()
  }
}

export function login(username, password, dispatch) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${urlServer}/api/user/login`,
      data: {
        username,
        password,
      },
      config: { headers: { 'Content-Type': 'application/json' } },
    })
      .then(responseUserLogin => {
        let suspendSession = new Date()
        suspendSession.setHours(suspendSession.getHours() + 2)
        const dataUser = responseUserLogin.data
        const dataUserLS = {
          email: username,
          name: dataUser.user.name,
        }
        window.localStorage.setItem('app.UserData', JSON.stringify(dataUserLS))
        window.localStorage.setItem('app.Role', dataUser.user.role)
        window.localStorage.setItem('suspendSession', suspendSession)
        window.localStorage.setItem('tokenTling', dataUser.session_token)
        window.localStorage.setItem('enterpriseData', JSON.stringify(dataUser.user.enterprise))
        window.localStorage.setItem('_idEnterprise', dataUser.user.enterprise._id)
        window.localStorage.setItem(
          'filterDefault',
          JSON.stringify({ title: 'SurveysAdmin.filterData.thirty', key: 8 }),
        )

        // ----
        if (dataUser.user.role === 'redeemman') {
          dispatch(push('/admin/redeemPoints'))
        } else {
          dispatch(push('/admin/DashboardTling'))
        }

        dispatch(_setHideLogin(true))
        notification.open({
          type: 'success',
          message: 'Bienvenido ',
          description: 'Bienvenido al administrador de tling',
        })
        resolve('LOGGED')
      })
      .catch(error => {
        dispatch(push('/login'))
        dispatch(_setFrom(''))
        reject('NO_LOGED')
      })
  })
}
export const logout = () => (dispatch, getState) => {
  dispatch(
    setUserState({
      userState: {
        email: '',
        role: '',
      },
    }),
  )
  window.localStorage.clear()
  dispatch(push('/login'))
}

const initialState = {
  // APP STATE
  from: '',
  isUpdatingContent: false,
  isLoading: false,
  activeDialog: '',
  dialogForms: {},
  submitForms: {},
  isHideLogin: false,

  // LAYOUT STATE
  layoutState: {
    isMenuTop: false,
    menuMobileOpened: false,
    menuCollapsed: false,
    menuShadow: true,
    themeLight: true,
    squaredBorders: false,
    borderLess: true,
    fixedWidth: false,
    settingsOpened: false,
  },

  // USER STATE
  userState: {
    email: '',
    role: '',
  },
}

export default createReducer(
  {
    [_setFrom]: (state, from) => ({ ...state, from }),
    [_setLoading]: (state, isLoading) => ({ ...state, isLoading }),
    [_setHideLogin]: (state, isHideLogin) => ({ ...state, isHideLogin }),
    [setUpdatingContent]: (state, isUpdatingContent) => ({ ...state, isUpdatingContent }),
    [setUserState]: (state, { userState }) => ({ ...state, userState }),
    [setLayoutState]: (state, param) => {
      const layoutState = { ...state.layoutState, ...param }
      const newState = { ...state, layoutState }
      window.localStorage.setItem('app.layoutState', JSON.stringify(newState.layoutState))
      return newState
    },
    [setActiveDialog]: (state, activeDialog) => {
      const result = { ...state, activeDialog }
      if (activeDialog !== '') {
        const id = activeDialog
        result.dialogForms = { ...state.dialogForms, [id]: true }
      }
      return result
    },
    [deleteDialogForm]: (state, id) => {
      const dialogForms = { ...state.dialogForms }
      delete dialogForms[id]
      return { ...state, dialogForms }
    },
    [addSubmitForm]: (state, id) => {
      const submitForms = { ...state.submitForms, [id]: true }
      return { ...state, submitForms }
    },
    [deleteSubmitForm]: (state, id) => {
      const submitForms = { ...state.submitForms }
      delete submitForms[id]
      return { ...state, submitForms }
    },
  },
  initialState,
)



// WEBPACK FOOTER //
// ./src/ducks/app.js